import messageListEventBus, { BUS_EVENTS } from '~/components/MessageList/messageListEventBus';

export function installZopim(store) {
  if (!window.zChat) {
    return;
  }

  const { zChat } = window;
  zChat.init({
    account_key: process.env.ZOPIM_KEY,
    suppress_console_error: true,
  });

  zChat.on('connection_update', (status = {}) => {
    messageListEventBus.$emit(BUS_EVENTS.connectionUpdate, status);

    store.dispatch('zopim/app/setStatus', status);
    store.dispatch('zopim/app/setDepartments', zChat.getAllDepartments());
  });
  return zChat;
}

export default async ({ store }, inject) => {
  const zopim = await installZopim(store);
  if (zopim) inject('zopim', zopim);
};
